import React, { useState } from 'react';
import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatToolTip from '@components/common/satUI/SatToolTip';
import SatButton from '@components/common/satUI/SatButton';
import classNames from 'classnames';
import { getDateByformat } from '@common/utils/date';

const ThankyouCallList = props => {
  const {
    thankyouCallList,
    onClickSortBtn,
    searchParams,
    handleClickListEvent,
    status,
  } = props;

  const [isShowStatusTooltip, setIsShowStatusTooltip] = useState(false);

  const columns = [
    {
      title: '청약일자',
      dataIndex: 'applyDate',
      key: 'applyDate',
      sortable: true,
      width: '12%',
      render: value => (
        <span className="t-date small">
          {getDateByformat(value, 'yyyy.MM.dd')}
        </span>
      ),
    },
    {
      title: (
        <>
          완전판매모니터링 (해피콜) 상태
          <SatToolTip
            show={isShowStatusTooltip}
            setShow={flag => setIsShowStatusTooltip(flag ? true : false)}
            customStyleClass={'w-430'}
            iconStyleClass={'ico-alim5'} // to do ico-alim5
            toolTips={[
              {
                title: '',
                message: () => (
                  <ul className="label-list">
                    <li>
                      <div className="lable-box">
                        <span className="status-label return">연락불가</span>
                      </div>
                      <p className="explain-box">
                        3회 이상 연결시도 후 부재 건. 통화 가능 시간을 확인 후
                        통화가능 시간예약을 등록해주세요
                      </p>
                    </li>
                    <li>
                      <div className="lable-box">
                        <span className="status-label return">
                          필수사항미안내
                        </span>
                      </div>
                      <p className="explain-box">
                        모니터링 결과 보완(재설명필요)항목 발생 . 고객 재설명 후
                        [통화가능 시간예약]을 통해 모바일재모니터링 또는
                        콜재모니터링(모바일비대상일 경우)을 요청해 주세요
                      </p>
                    </li>
                    <li>
                      <div className="lable-box">
                        <span className="status-label return">철회예정</span>
                      </div>
                      <p className="explain-box">
                        모니터링 과정 중 청약철회 의사 확인 .고객상담 후
                        모니터링이 필요하시면 [통화시간 예약]을 통해
                        모바일알림톡 재발송 요청 또는 콜모니터링 시간을 요청해
                        주세요.
                      </p>
                    </li>
                    <li>
                      <div className="lable-box">
                        <span className="status-label under-review">
                          진행중
                        </span>
                      </div>
                      <p className="explain-box">
                        콜 진행 대기 또는 1회이상 콜이 시도된 상태입니다
                        <br />
                        모바일 대상 건일 경우 빠르고 편리한 모바일모니터링을
                        권유해주세요.
                      </p>
                    </li>
                    <li>
                      <div className="lable-box">
                        <span className="status-label complete">완료</span>
                      </div>
                      <p className="explain-box">
                        모니터링 완료된 상태로 아래 상태를 모두 포함합니다.
                        <br />
                        - 정상 - 완료 <br />
                        - 모집경로상이: 지점 미결 ( "개인정보취득경로 확인서"
                        작성)
                        <br />
                        - 고지의무 : 지점 미결( 고객 추가고지 항목 보완 )<br />
                        - 자금세탁방지업무 상이 : 국적/직업정보 상이( 심사자
                        확인 후 수정)
                        <br />
                        - 3대 기본 미이행 : 자필서명미이행/면담미필(불완전판매)
                        <br />
                      </p>
                    </li>
                  </ul>
                ),
              },
            ]}
          />
        </>
      ),
      dataIndex: 'procTypeCode',
      key: 'procTypeCode',
      width: '21%',
      setColumnStyle: 'text-center',
      render: (value, row) => {
        switch (value) {
          case '841': // 정상
          case '842': // 무효
          case '843': // 3대기본미이행
          case '844': // 30일 경과
          case '845': // 적합성미이행
          case '846': // 자금세탁방지업무상이
          case '847': // 추가고지
          case '816': // 계약자완료
          case '817': // 피보험자완료
          case '848': // 모집경로상이
            return <span className="status-label complete">완료</span>;
          case '811': // 진행중
          case '821': // 대기
          case '822': // 분배
          case '818': // 친권자진행중
            return <span className="status-label under-review">진행중</span>;
          case '814': // 보완(필수미안내)
          case '833': // 철회예정
            return <span className="status-label return">철회예정</span>;
          case '813': // 보완(필수미안내)
          case '815': // 보완(상품적합성미안내)
          case '832': // 필수사항미안내
          case '834': // 상품적합성미안내
            return <span className="status-label return">필수사항미안내</span>;
          case '812': // 보완(연락불가)
          case '831': // 연락불가
            return <span className="status-label return">연락불가</span>;
          default:
            return (
              <span className="status-label under-review">
                {row.procTypeName}
              </span>
            );
        }
      },
    },
    {
      title: '증권번호',
      dataIndex: 'policyNo',
      key: 'policyNo',
      width: '18%',
      render: (value, row) => (
        <div className="icon_box">
          {/* 20230913 회사별 아이콘 삭제 */}
          {/* <span
            className={classNames('ico2', {
              'ico-k': row.compCd === PRODUCT_COMP_CD.kb,
              'ico-p': row.compCd === PRODUCT_COMP_CD.pr,
            })}
          ></span> */}
          <div className="insu-tit">
            <SatButton
              styleClass="btn-view3 f-15"
              label={value}
              onClick={() => {
                handleClickListEvent('policyNo', row);
              }}
            />
          </div>
        </div>
      ),
    },
    {
      title: '계/피 여부',
      dataIndex: 'callTarget',
      key: 'callTarget',
      width: '10%',
      render: (value, row) => {
        return value === '계약자only' ? '계피동일' : value;
      },
    },
    {
      title: '고객명',
      dataIndex: 'ownerName',
      key: 'ownerName',
      width: '11%',
      render: (value, row) => {
        return row.callTarget === '피보험자' ? row.insuredName : value;
      },
    },
    {
      title: '모바일 알림톡 발송',
      dataIndex: 'mobileDispYN',
      key: 'mobileDispYN',
      width: '14%',
      render: (value, row) => {
        if (value) {
          return (
            <SatButton
              styleClass={`ico ico-kakao${
                ['817', '832', '833', '841'].includes(row.procTypeCode)
                  ? '2'
                  : row.mobileDispYN === 'N'
                  ? '2'
                  : ''
              }`}
              label={'알림톡 발송'}
              onClick={() => {
                if (['817', '832', '833', '841'].includes(row.procTypeCode)) {
                  return false;
                }
                if (row.mobileDispYN === 'N') {
                  return false;
                } else {
                  handleClickListEvent('alarm', row);
                }
              }}
            />
          );
        }
      },
    },
  ];

  const sortingOption = [
    {
      sortBy: 'preceiptDate',
      order: searchParams.sort === '-applyDate' ? 'desc' : 'asc',
    },
  ];

  return (
    <SatDataGrid
      columns={columns}
      dataSource={thankyouCallList}
      customStyleClass="bd-b-fix2"
      sortingOption={sortingOption}
      onSortChange={obj => onClickSortBtn(obj)}
      noDataRender={'검색결과가 없습니다.'}
      setRowStyle={'text-center'}
      useHeaderPinned
    />
  );
};

export default ThankyouCallList;
